export default function About() {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">

        {/* Üst - İki Kolon */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20">
          {/* Sol - Görsel */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src="/images/about/about-section.webp"
                alt="İzmir Lightbox üretim ekibi lightbox panelleri inceliyor"
                className="w-full h-64 md:h-[420px] object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
            </div>
            <div className="absolute -bottom-6 right-2 md:-right-4 bg-red-600 text-white rounded-xl p-4 md:p-5 shadow-lg">
              <div className="text-2xl md:text-3xl font-black">15+</div>
              <div className="text-white text-sm font-medium">Yıllık Deneyim</div>
            </div>
            <div className="absolute top-4 left-2 md:top-6 md:-left-4 bg-white rounded-xl p-3 md:p-4 shadow-lg border border-gray-100">
              <div className="text-xl md:text-2xl font-black text-gray-900">5000+</div>
              <div className="text-gray-500 text-xs font-medium">Tamamlanan Proje</div>
            </div>
          </div>

          {/* Sağ - İçerik */}
          <div>
            <div className="inline-flex items-center gap-2 text-red-600 text-sm font-semibold uppercase tracking-widest mb-4">
              <span className="w-8 h-0.5 bg-red-600 inline-block"></span>
              Hakkımızda
            </div>

            <h2 className="text-4xl md:text-5xl font-black text-gray-900 leading-tight mb-6">
              Lightbox Nedir?
            </h2>

            <p className="text-gray-600 text-base leading-relaxed mb-4">
              <strong>Lightbox</strong>, içten aydınlatmalı reklam ve tanıtım ürünüdür.
              Alüminyum veya plastik çerçeve içine yerleştirilen LED ışık kaynağı sayesinde,
              üzerine baskılı görsel veya metin gece gündüz net bir şekilde görünür hale gelir.
            </p>
            <p className="text-gray-600 text-base leading-relaxed mb-6">
              <strong>İzmir Lightbox</strong> olarak, İzmir ve Ege bölgesindeki binlerce reklam ajansı ve işletmeye
              özel ölçü ve tasarımda lightbox üretimi yapıyoruz. Tek kutu lightboxtan büyük ölçekli
              projelere kadar her ihtiyaca çözüm sunuyoruz.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
              {[
                { icon: 'ri-user-star-line', title: 'Müşteri Odaklı', desc: 'Her projeye özel çözümler' },
                { icon: 'ri-shield-check-line', title: 'Kalite Garantisi', desc: '2 yıl garanti ile teslim' },
                { icon: 'ri-time-line', title: 'Hızlı Teslimat', desc: '3-5 iş günü üretim' },
              ].map((f) => (
                <div key={f.title} className="flex flex-col items-start gap-2 p-4 bg-gray-50 rounded-xl">
                  <div className="w-10 h-10 flex items-center justify-center bg-red-100 rounded-lg">
                    <i className={`${f.icon} text-red-600 text-lg`}></i>
                  </div>
                  <div className="font-bold text-gray-900 text-sm">{f.title}</div>
                  <div className="text-gray-500 text-xs">{f.desc}</div>
                </div>
              ))}
            </div>

            <a
              href="#products"
              className="inline-flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white font-bold px-7 py-3 rounded-md transition-colors cursor-pointer whitespace-nowrap"
            >
              Ürünlerimizi İncele
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>

        {/* Alt - Lightbox Hakkında Bilgi Kartları */}
        <div className="border-t border-gray-100 pt-16">
          <div className="text-center mb-10">
            <p className="text-red-600 text-sm font-semibold uppercase tracking-widest mb-2">Lightbox Rehberi</p>
            {/* H3'ler üst H2: Lightbox Nedir? altına bağlıdır — ara H2 kaldırıldı */}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {/* H3: Lightbox Tabela Ne İşe Yarar? */}
            <div className="bg-gray-50 rounded-2xl p-6">
              <div className="w-10 h-10 flex items-center justify-center bg-red-100 rounded-xl mb-4">
                <i className="ri-question-answer-line text-red-600 text-lg"></i>
              </div>
              <h3 className="font-bold text-gray-900 text-base mb-3">Lightbox Tabela Ne İşe Yarar?</h3>
              <p className="text-gray-500 text-sm leading-relaxed">
                Mağaza ve işletmelerin gece-gündüz fark etmeksizin müşteri dikkatini çekmesini sağlar.
                Markanızı rakiplerinizden öne çıkarır, müşteri trafiğini artırır.
              </p>
            </div>

            {/* H3: İç Mekan ve Dış Mekan Lightbox Farkları */}
            <div className="bg-gray-50 rounded-2xl p-6">
              <div className="w-10 h-10 flex items-center justify-center bg-red-100 rounded-xl mb-4">
                <i className="ri-contrast-2-line text-red-600 text-lg"></i>
              </div>
              <h3 className="font-bold text-gray-900 text-base mb-3">İç Mekan ve Dış Mekan Lightbox Farkları</h3>
              <p className="text-gray-500 text-sm leading-relaxed">
                İç mekan modeller IP20 sınıfı olup standart ortamlara uygundur.
                Dış mekan modeller IP65 sertifikalı; yağmur, kar ve UV ışınlarına karşı tam koruma sağlar.
              </p>
            </div>

            {/* H3: Lightbox mı Kutu Harf mi? */}
            <div className="bg-gray-50 rounded-2xl p-6">
              <div className="w-10 h-10 flex items-center justify-center bg-red-100 rounded-xl mb-4">
                <i className="ri-scales-line text-red-600 text-lg"></i>
              </div>
              <h3 className="font-bold text-gray-900 text-base mb-3">Lightbox mı Kutu Harf mi?</h3>
              <p className="text-gray-500 text-sm leading-relaxed">
                Lightbox geniş yüzey aydınlatması için idealdir. Kutu harf 3 boyutlu kurumsal kimlik gerektirir.
                İhtiyacınıza ve bütçenize göre en uygun seçeneği birlikte belirleriz.
              </p>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}
